const USER_INFOS_REFRESH_FREQUENCY = 30 * 60 * 1000;

export default {
  /**
   * USER
   */
  favorites: (state) =>
    state.userFavorites.filter((f) => {
      return (
        state.focusKnowledge && f && f.knowledge === state.focusKnowledge.value
      );
    }),
  focusItemIsFavorite(state, getters) {
    return getters.favorites && getters.favorites.length && state.focusNavItem
      ? getters.favorites.find((f) => f.id === state.focusNavItem.id)
      : null;
  },
  hasEditionRights(_state, _getters, rootState) {
    return rootState.userPermissions.includes('EDIT_KNOWLEDGE_BASE');
  },
  refreshUserInfos: (state) => (date) =>
    state.lastUserInfosRefresh
      ? state.lastUserInfosRefresh + USER_INFOS_REFRESH_FREQUENCY < date
      : true,

  /**
   * GENERAL
   */
  loading: (state) => state.loading,
  companyColor(_state, _getters, rootState) {
    const companyColor = rootState.companyPreferences.find(
      (cp) => cp.type === 'PRIMARY_COLOR',
    );
    return companyColor ? companyColor.value : '#0081f9';
  },
  companySecondaryColor(_state, _getters, rootState) {
    const companyColor = rootState.companyPreferences.find(
      (cp) => cp.type === 'SECONDARY_COLOR',
    );
    return companyColor ? companyColor.value : '#0081f9';
  },
  companyLogo(_state, _getters, rootState) {
    return (
      rootState.companyLogo ||
      'https://maydaystatic.blob.core.windows.net/assets/mayday-rounded.png'
    );
  },

  /**
   * KNOWLEDGE
   */
  knowledges: (state) => state.knowledges,
  focusKnowledge: (state) => state.focusKnowledge,
  focusKnowledgeId: (state) =>
    state.focusKnowledge ? state.focusKnowledge.id : null,
  focusKnowledgeValue: (state) =>
    state.focusKnowledge ? state.focusKnowledge.value : null,
  focusKnowledgeLanguage: (state) =>
    state.focusKnowledge ? state.focusKnowledge.defaultLanguage : null,
  focusKnowledgeRoots: (state) => state.focusKnowledgeRoots,
  focusKnowledgeLabel: (state) =>
    state.focusKnowledge ? state.focusKnowledge.label : null,
  focusKnowledgeIsMultilinguale: (state) =>
    state.focusKnowledge &&
    state.focusKnowledge.supportedLanguages &&
    state.focusKnowledge.supportedLanguages.length > 1,
  focusKnowledgeLanguages: (state) =>
    state.focusKnowledge ? state.focusKnowledge.supportedLanguages : [],
  caseLabelFromNavPath: (state) => (caseId) => {
    const caseIdx = state.path.findIndex((c) => c.id === caseId);
    if (caseIdx > -1) return state.path[caseIdx].label;
    return '';
  },

  /**
   * NAVIGATION
   */
  navigationLanguage: (state) => state.navigationLanguage,
  navPath(state) {
    return state.path;
  },
  diagPath(state) {
    return state.diagPath;
  },
  focusNavItem(state) {
    return state.focusNavItem;
  },
  focusDiagItem(state) {
    return state.focusDiagItem;
  },
  previousItems(state) {
    return state.previousItems || [];
  },
  showNode(state) {
    return (
      state.focusNavItem ||
      state.focusDiagItem ||
      state.query.length > 0 ||
      state.filters.length > 0
    );
  },
  showSearch(state) {
    return state.query.length > 0 || state.filters.length > 0;
  },

  /**
   * SEARCH
   */
  searchQuery(state) {
    return state.query;
  },
  searchFilters(state) {
    return state.filters;
  },
  searchFocusLevel(state) {
    return state.focusLevel;
  },
  recentSearches(state) {
    return state.recentSearches || [];
  },
  frequentSearches(state) {
    return state.frequentSearches || [];
  },
  searchResults(state) {
    return state.results;
  },
  searchTotalCount(state) {
    return state.totalCount;
  },
  searchSize(state) {
    return state.size;
  },
  preFilters(_state, getters) {
    return getters.searchFilters.reduce((acc, filter) => {
      if (filter.key !== 'entity') {
        if (acc[filter.key]) {
          acc[filter.key].push(filter.value);
        } else {
          acc[filter.key] = [filter.value];
        }
      }
      return acc;
    }, {});
  },
  entityType(_state, getters) {
    return getters.preFilters.type || null;
  },
  labels(_state, getters) {
    return getters.preFilters.categories || [];
  },
  currentFilter(state, getters) {
    return {
      filterType: ['attached-contents', 'cases'],
      entityType: getters.entityType,
      search: getters.searchQuery,
      knowledge: getters.focusKnowledgeValue,
      product: null,
      cases: null,
      status: [{ key: 'published', value: true }],
      accessRestrictions: null,
      labels: getters.labels,
      isContribution: null,
      searchFrom: state.searchFrom,
      size: state.size,
    };
  },
};
